<template>
  <div class="nav-panel">
    <div class="nav-panel__logo">
      <router-link :to="{name: 'members'}">
        <img @click="clearMembersStore" class="nav-panel__logo" src="../../../images/logo/logo.png" />
      </router-link>
    </div>
    <div class="nav-panel__profile">
      <div v-if="user" class="nav-profile">
        <router-link :to="{name: 'user'}">
          <div
            class="nav-profile__avatar"
            :class="$route.name === 'user' ? 'nav-profile__avatar--bordered' : ''"
            :style="{ 'background-image':'url(' + user.web_avatar_url + '?h=450)' }"
          >
          </div>
        </router-link>
        <div class="nav-profile__box-data">
          <div>
            <router-link :to="{name: 'user'}">
              <span class="nav-profile__name">{{ user.name }}, {{ user.age }}</span>
            </router-link>
          </div>
          <span class="nav-profile__address">{{ user.regular_address.slice(6) }}</span>
        </div>
      </div>
    </div>
    <div class="nav-panel__wallet">
      <div class="nav-wallet__menu">
        <p>Menu<span>.</span></p>
      </div>
      <router-link class="nav-wallet__wallet" :to="{ name: 'more-settings' }">
        <span v-if="user" class="nav-wallet__coins">{{ user.coins + user.free_coins }} <img src="../../../images/others/coin.svg" alt="" class="coin-icon"></span>
        <i class="demo-icon icon-wallet"></i>
      </router-link>
    </div>
    <div class="nav-panel__menu">
      <ul class="nav-panel__links">
        <li
          class="nav-panel__link-item"
          :class="[ $route.name === 'members' && $route.hash !== '#Visitors' ? 'nav-panel__link-item--active' : '' ]"
        >
          <router-link :to="{ name: 'members' }" class="nav-panel__link">
            <div @click="clearMembersStore" class="nav-panel__link-button">
              <img
                v-if="$route.name === 'members'"
                src="../../../images/menu/members-active.svg"
                alt=""
                class="nav-panel__icon"
              >
              <img
                v-if="$route.name !== 'members'"
                src="../../../images/menu/members.svg"
                alt=""
                class="nav-panel__icon"
              >
            </div>

            <span @click="clearMembersStore" id="menu-members" class="nav-panel__link-label">{{ trans.get('top_bar.members') }}</span>
          </router-link>
        </li>

        <li
          class="nav-panel__link-item nav-panel__link-item--accented"
          :class="{ 'nav-panel__link-item--active': $route.name === 'match_game' }"
        >

          <router-link :to="{ name: 'match_game' }" class="nav-panel__link">
            <div class="nav-panel__link-button">
              <img v-if="$route.name === 'match_game'" src="../../../images/menu/match-active.svg" alt="" class="nav-panel__icon">
              <img v-if="$route.name !== 'match_game'" src="../../../images/menu/match.svg" alt="" class="nav-panel__icon">
            </div>
            <span class="nav-panel__link-label" id="menu-match-game">{{ trans.get('top_bar.match_game') }}</span>
          </router-link>
        </li>

        <li class="nav-panel__link-item nav-panel__link-item--chat" :class="{'nav-panel__link-item--active': $route.name === 'chat'}">
          <router-link :to="{name: 'chat'}" class="nav-panel__link">
            <div class="nav-panel__link-button">
              <img v-if="$route.name === 'chat'" src="../../../images/menu/chat-active.svg" alt="" class="nav-panel__icon">
              <img v-if="$route.name !== 'chat'" src="../../../images/menu/chat.svg" alt="" class="nav-panel__icon">
              <chat-unread-messages-component></chat-unread-messages-component>
            </div>
            <span class="nav-panel__link-label" id="menu-chat">{{ trans.get('top_bar.messages') }}</span>
          </router-link>
        </li>

        <li
          class="nav-panel__link-item"
          :class="{ 'nav-panel__link-item--active': $route.name === 'more-settings' }"
        >
          <router-link :to="{ name: 'more-settings' }" class="nav-panel__link">
            <div class="nav-panel__link-button">
              <img v-if="$route.name === 'more-settings'" src="../../../images/menu/settings-active.svg" alt="" class="nav-panel__icon">
              <img v-if="$route.name !== 'more-settings'" src="../../../images/menu/settings.svg" alt="" class="nav-panel__icon">
            </div>
            <span class="nav-panel__link-label">{{ trans.get('top_bar.settings') }}</span>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="nav-panel__members">
      <div v-if="show && online.length" class="onlines__wrapper">
        <p class="onlines-header">{{ trans.get('common.online') }}</p>
        <div class="onlines__members">
          <div
            v-for="(profile,k) in width < 1200 ? online.slice(0, 6) : online.slice(0, 8)"
            class="js-online-profile" :data-profile-id="k"
          >
            <router-link :to="{name: 'profile', params: { id: profile.id}}">
              <div
                class="avatar-single avatar-single--medium-small avatar-single--square"
                :style="{'background-image':'url(' + profile.avatar_url + '?p=tiny)'}"
              >
                <div class="avatar-single__online-status"></div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="matches__wrapper">
        <p class="matches-header">{{ trans.get('pages:chat.tabs.matches') }}</p>
        <div v-if="matches.length > 0" class="matches__members">
          <div class="matched-user" v-for="match in width < 1200 ? matches.slice(0, 5) : matches.slice(0, 7)">
            <router-link :to="{ name: 'profile', params: { id: match.id } }">
              <div
                class="avatar-single avatar-single--medium-small avatar-single--square"
                :style="{'background-image':'url(' + match.avatar_url + '?p=tiny)'}"
              >
                <div v-if="match.is_online" class="avatar-single__online-status"></div>
              </div>
            </router-link>
          </div>
          <router-link :to="{ name: 'chat' }">
            <button @click="chatMatches" class="matches__button" v-if="matches.length > 0">
              <i class="demo-icon icon-email" />
            </button>
            <!--                        <button class="matches-button" v-if="matches.length > 0">{{trans.get('pages:members.matches.show_all_button')}}</button>-->
          </router-link>
        </div>
        <div v-else class="no-matches__wrapper">
          <img src="../../../images/background/no-matches.png" alt="No matches image">
          <div class="no-matches__text">
            <h2>{{ trans.get('pages:members.matches.no_maches') }}<span>.</span></h2>
            <p>{{ trans.get('pages:members.matches.hint') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ClearMembersStore from '../../../../js/front/views/elements/ClearMembersStore';

export default {
  components: {},
  mixins: [ClearMembersStore],
  data() {
    return {
      show: true,
      width: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
    ...mapGetters('profiles', {
      matches: 'getMatches',
      online: 'getOnline',
    }),
  },
  watch: {},
  methods: {
    chatMatches() {
      this.$store.commit('chat/setShowMatchedTab', true);
    },
  },
  mounted() {
    let vm = this;

    this.$store.dispatch('profiles/loadMatches');
    this.$store.dispatch('profiles/loadOnline');
    window.onresize = function () {
      document.body.height = window.innerHeight;
    };
    window.onresize();

    vm.$eventHub.$on('FreshProfile', (profile) => {
      vm.$store.commit('profiles/setOnlineProfile', profile);
    });

    vm.$nextTick(() => {
      $('#navOnlineOwlContainer').on('click', '.js-online-profile', function () {
        vm.clickAction(vm.online[this.dataset.profileId]);
      });
    });
  },
};
</script>
